import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c7d9b1d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "time" }
const _hoisted_2 = { class: "clock" }
const _hoisted_3 = { class: "date" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  style: {"margin-top":"44px"}
}
const _hoisted_6 = { key: 2 }

import { reactive, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TimeAndCalendar',
  setup(__props) {

let time = ref('00:00:00');

let date = ref('');

let yiyan = reactive({
  content: '',
  from: '',
  author: '',
});

const freshYiyan = () => {
  const options = { 
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
   };
  setTimeout(() => {
    fetch('https://v1.hitokoto.cn/?c=d', options)
      .then((response) => {
        response.json().then((res) => {
          yiyan.content = res.hitokoto;
          yiyan.from = res.from;
          yiyan.author = res.from_who;
        });
      })
      .catch((err) => console.error(err));
  });
};

freshYiyan();

function updateTime() {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth() + 1; // 月份是从0开始的
  const day = now.getDate();
  const dayOfWeek = now.getDay(); // 星期几的数字表示
  const weekdays = [
    '星期日',
    '星期一',
    '星期二',
    '星期三',
    '星期四',
    '星期五',
    '星期六',
  ];
  const chineseDay = weekdays[dayOfWeek];
  date.value = `${year}年${month}月${day}日 ${chineseDay}`;
  const timeString = now.toLocaleTimeString(undefined, {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  });
  time.value = timeString;
}

// 更新时间显示
updateTime();

// 每秒更新一次时间
setInterval(updateTime, 1000);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(time)), 1),
    _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(date)), 1),
    _createElementVNode("div", {
      class: "yiyan",
      onClick: freshYiyan
    }, [
      (_unref(yiyan).content)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_unref(yiyan).content), 1))
        : _createCommentVNode("", true),
      (_unref(yiyan).from)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, "《" + _toDisplayString(_unref(yiyan).from) + "》", 1))
        : _createCommentVNode("", true),
      (_unref(yiyan).author)
        ? (_openBlock(), _createElementBlock("p", _hoisted_6, "-- " + _toDisplayString(_unref(yiyan).author) + " --", 1))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})